import type { CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { CheckMarkIcon } from '#src/assets/ui/icons/CheckMarkIcon.tsx'
import { CookieControllerList } from '#src/assets/ui/overview/components/CookieControllerList.tsx'
import { ExpandableSection } from '#src/assets/ui/overview/ExpandableSection.tsx'
import { Heading } from '#src/assets/ui/shared/components/Heading.tsx'
import { Paragraph } from '#src/assets/ui/shared/components/Paragraph.tsx'
import type { CookieRecord } from '#src/services/cookieTranslationService/types.ts'

export function NecessaryCookiesSection({
  t,
  cookies,
  cookieDomain,
}: {
  t: CookieConsentTranslator
  cookies: Array<CookieRecord>
  cookieDomain: string
}) {
  return (
    <ExpandableSection
      icon={<CheckMarkIcon />}
      title={t('necessaryCookiesTitle')}
    >
      <Paragraph>{t('necessaryCookiesDescription')}</Paragraph>
      {cookies.length > 0 ? (
        <>
          <Heading level={3}>{t('necessaryCookiesProvidersQuestion')}</Heading>
          <Paragraph>{t('necessaryCookiesProvidersAnswer')}</Paragraph>
          <CookieControllerList
            cookies={cookies}
            fallbackDomain={cookieDomain}
            t={t}
          />
        </>
      ) : null}
    </ExpandableSection>
  )
}
